import React, { useRef, useState, useEffect } from 'react';
import styles from '../anacouto_naildesigner/anacouto_naildesigner.module.scss';
import Perfil from './src/perfil.png';
import catalogoPdf from './src/catalogo-anacouto_naildesigner.pdf';
import LinkPersonalizado10 from '../../components/LinkPersonalizado10/linkPersonalizado10.tsx';

const Anacouto_naildesigner: React.FC = () => {
    const imgRef = useRef<HTMLImageElement>(null);
    const [height, setHeight] = useState(window.innerHeight);

    useEffect(() => {
        const handleResize = () => {
            setHeight(window.innerHeight);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <div className={styles.anacouto_naildesigner}>
            <div className={styles["body-thunder"]} style={{ minHeight: `${height}px` }}>
                <div className={styles["background-thunder"]}></div>
                <div className={`${styles["container-thunder"]}`} >
                    <div className={styles["img-wrapper"]}>
                        <img
                            ref={imgRef}
                            className={styles["img-perfil"]}
                            src={Perfil}
                            alt="Profile Picture"
                        />
                    </div>
                    <h1 className="mt-4 mb-0">ANA COUTO</h1>
                    <p className="mb-4">Nail Designer</p>
                    <div className={styles.links}>
                        <LinkPersonalizado10
                            href="https://www.instagram.com/anacouto_naildesigner?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                            title="Instagram"
                            backgroundColor="transparent"
                            backgroundColorHover="transparent"
                            colorText="#fff"
                        />
                        <LinkPersonalizado10
                            href="https://wa.me/5517991060469?text=Ol%C3%A1%2C%20gostaria%20de%20agendar%20um%20hor%C3%A1rio."
                            title="Whatsapp"
                            backgroundColor="transparent"
                            backgroundColorHover="transparent"
                            colorText="#fff"
                        />
                        <LinkPersonalizado10
                            href={catalogoPdf}
                            title="Catálogo"
                            backgroundColor="transparent"
                            backgroundColorHover="transparent"
                            colorText="#fff"
                        />
                        <LinkPersonalizado10
                            href="https://maps.app.goo.gl/Etk2VXhrSbF7JcP7A"
                            title="Localização"
                            backgroundColor="transparent"
                            backgroundColorHover="transparent"
                            colorText="#fff"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Anacouto_naildesigner;
